<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_5"></a><a id="contents">CONTENTS</a></h2><a id="contents">
</a><p class="tocchap"><a id="contents"></a><a href="#/xhtml/preface#preface"><span class="small">PREFACE</span><br/>THE FLYING HERITAGE COLLECTION</a></p>
<p class="tocchap"><a href="#/xhtml/intro#intro"><span class="small">INTRODUCTION</span><br/>TECHNOLOGY OVER TIME</a></p>
<p class="tocchap"><span href="#/xhtml/ch01#ch01" title="Link target outside of Sample"><span class="small">CHAPTER 1</span><br/><big>THE BEGINNING</big></span></p>
<p class="tocsec">CURTISS JN-4D JENNY<br/>POLIKARPOV U-2 (PO-2) LIGHT NIGHT BOMBER</p>
<p class="tocchap"><span href="#/xhtml/ch02#ch02" title="Link target outside of Sample"><span class="small">CHAPTER 2</span><br/><big>THE PRIMITIVES</big></span></p>
<p class="tocsec">POLIKARPOV I-16 TYPE 24 RATA<br/>HAWKER HURRICANE MK.XII</p>
<p class="tocchap"><span href="#/xhtml/ch03#ch03" title="Link target outside of Sample"><span class="small">CHAPTER 3</span><br/><big>THE RIVALS</big></span></p>
<p class="tocsec">MESSERSCHMITT BF 109 E-3<br/>SUPERMARINE SPITFIRE F.MK.VC</p>
<p class="tocchap"><span href="#/xhtml/ch04#ch04" title="Link target outside of Sample"><span class="small">CHAPTER 4</span><br/><big>DUELS IN CHINA</big></span></p>
<p class="tocsec">CURTISS P-40C TOMAHAWK<br/>NAKAJIMA KI-43 HAYABUSA OSCAR TYPE I</p>
<p class="tocchap"><span href="#/xhtml/ch05#ch05" title="Link target outside of Sample"><span class="small">CHAPTER 5</span><br/><big>THE ICONS</big></span></p>
<p class="tocsec">MITSUBISHI A6M3-22 REISEN (ZERO)<br/>NORTH AMERICAN P-51D MUSTANG</p>
<p class="tocchap"><span href="#/xhtml/ch06#ch06" title="Link target outside of Sample"><span class="small">CHAPTER 6</span><br/><big>THE BUTCHER BIRDS</big></span></p>
<p class="tocsec">FOCKE-WULF FW 190 A-5<br/>FOCKE-WULF FW 190 D-13</p>
<p class="tocchap"><span href="#/xhtml/ch07#ch07" title="Link target outside of Sample"><span class="small">CHAPTER 7</span><br/><big>ON THE ATTACK</big></span></p>
<p class="tocsec">FIESELER FI 156 C-2 STORCH<br/>ILYUSHIN IL-2M3 SHTURMOVIK<br/>NORTH AMERICAN B-25J MITCHELL</p>
<p class="tocchap"><span href="#/xhtml/ch08#ch08" title="Link target outside of Sample"><span class="small">CHAPTER 8</span><br/><big>THE BRUISERS</big></span></p>
<p class="tocsec">REPUBLIC P-47D THUNDERBOLT<br/>GRUMMAN F6F-5 HELLCAT</p>
<p class="tocchap"><span href="#/xhtml/ch09#ch09" title="Link target outside of Sample"><span class="small">CHAPTER 9</span><br/><big>THE RADICALS</big></span></p>
<p class="tocsec">MESSERSCHMITT ME 163 B-1 KOMET<br/>MESSERSCHMITT ME 262 A-1A</p>
<p class="tocchap"><span href="#/xhtml/about#about" title="Link target outside of Sample">ABOUT THE AUTHOR</span></p>
<p class="tocchapa"><span href="#/xhtml/acknow#acknow" title="Link target outside of Sample">ACKNOWLEDGMENTS</span></p>
<p class="tocchapa"><span href="#/xhtml/photo#photo" title="Link target outside of Sample">IMAGE CREDITS</span></p>
<p class="tocchapa"><span href="#/xhtml/index#index" title="Link target outside of Sample">INDEX</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?8c811f82